import type { CardPackTier } from 'src/replicant/cardpack/cardpack.ruleset';
import {
  cardsCatalog,
  cardsCollectionSetId,
  type CardId,
  type CollectionId,
} from 'src/replicant/cards/cards.ruleset';

export const CARDS_REWARD_ICON_PATH = 'assets/ui/cards/hudButton/card_icon.png';
const CARDS_ASSETS_ROOT = `assets/cards/${cardsCollectionSetId}`;

export function cardsGetPackIcon(tier: CardPackTier) {
  return `assets/ui/cards/common/icon_pack${tier}.png`;
}

export function cardsGetCardIcon(cardId: CardId) {
  const { collection } = cardsCatalog[cardId];
  return `${CARDS_ASSETS_ROOT}/${collection}/${cardId}.png`;
}

export function cardsGetCollectionIcon(collectionId: CollectionId) {
  return `${CARDS_ASSETS_ROOT}/${collectionId}/icon.png`;
}
